import styled from 'styled-components';

import { $dmSansFontFamily, colorsPalettes, rgba, setFontVariant } from '@similarweb/styles';

import { Button } from '../../../components/Button';
import { StyledContainerWithNav } from '../../styles';
import { SamLogo } from '../InsightsHeading/SamLogo';

export const StyledOnboardingContainer = styled(StyledContainerWithNav)`
  padding: 44px 28px 0;
  display: block;
`;

export const OnboardingActionsTab = styled.div`
  text-align: center;
`;

export const StyledOnboardingTitle = styled.h1`
  font-family: ${$dmSansFontFamily};
  color: ${colorsPalettes.carbon[500]};
  font-size: 42px;
  font-weight: 300;
  line-height: 34px;
  margin: 0;
`;

export const StyledSubtitle = styled.p`
  margin: 16px 0 24px;
  ${setFontVariant('h5', rgba(colorsPalettes.carbon[500], 0.8))};
  font-size: 18px;
  font-weight: 400;
  line-height: 31px;
`;

export const StyledSamLogo = styled(SamLogo)`
  width: 160px;
  height: 76px;
  margin-right: 0;
  margin-left: -8px;
`;

export const StyledStartButton = styled(Button)`
  margin: 0 auto;
`;
